import React from 'react';
import { motion } from 'framer-motion';

// CSS-based animated wireframe background with Agastya Ventures brand colors
const WireframeBuilding = ({ className = "" }) => {
  return (
    <div className={`absolute inset-0 overflow-hidden ${className}`} data-testid="wireframe-building">
      {/* Grid background */}
      <div 
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: `
            linear-gradient(rgba(166, 122, 94, 0.3) 1px, transparent 1px),
            linear-gradient(90deg, rgba(166, 122, 94, 0.3) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px',
          transform: 'perspective(500px) rotateX(60deg) translateY(-50%)',
          transformOrigin: 'center center'
        }}
      />
      
      {/* Animated building wireframes */}
      <div className="absolute inset-0 flex items-center justify-center">
        {/* Center building */}
        <motion.div
          className="relative"
          animate={{ 
            rotateY: [0, 360],
          }}
          transition={{ 
            duration: 30, 
            repeat: Infinity, 
            ease: "linear" 
          }}
          style={{ transformStyle: 'preserve-3d' }}
        >
          {/* Main Tower */}
          <div 
            className="absolute w-32 h-64 border border-brand-brown/40"
            style={{
              transform: 'translateX(-50%) translateZ(0)',
              boxShadow: 'inset 0 0 30px rgba(166, 122, 94, 0.1)'
            }}
          >
            {/* Floor lines */}
            {[...Array(8)].map((_, i) => (
              <div 
                key={i}
                className="absolute w-full border-t border-brand-brown/20"
                style={{ top: `${(i + 1) * 12.5}%` }}
              />
            ))}
            {/* Vertical lines */}
            <div className="absolute h-full border-l border-brand-brown/20" style={{ left: '33%' }} />
            <div className="absolute h-full border-l border-brand-brown/20" style={{ left: '66%' }} />
          </div>

          {/* Left building */}
          <div 
            className="absolute w-20 h-40 border border-brand-brown/30"
            style={{
              transform: 'translateX(-120px) translateY(40px)',
              boxShadow: 'inset 0 0 20px rgba(166, 122, 94, 0.05)'
            }}
          >
            {[...Array(5)].map((_, i) => (
              <div 
                key={i}
                className="absolute w-full border-t border-brand-brown/15"
                style={{ top: `${(i + 1) * 20}%` }}
              />
            ))}
          </div>

          {/* Right building */}
          <div 
            className="absolute w-24 h-48 border border-brand-brown/30"
            style={{
              transform: 'translateX(80px) translateY(30px)',
              boxShadow: 'inset 0 0 20px rgba(166, 122, 94, 0.05)'
            }}
          >
            {[...Array(6)].map((_, i) => (
              <div 
                key={i}
                className="absolute w-full border-t border-brand-brown/15"
                style={{ top: `${(i + 1) * 16.66}%` }}
              />
            ))}
          </div>
        </motion.div>
      </div>

      {/* Floating particles */}
      <div className="absolute inset-0">
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute w-1 h-1 bg-brand-brown/30 rounded-full"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
            }}
            animate={{
              y: [-20, 20],
              opacity: [0.3, 0.6, 0.3],
            }}
            transition={{
              duration: 3 + Math.random() * 2,
              repeat: Infinity,
              delay: Math.random() * 2,
            }}
          />
        ))}
      </div>

      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-background/50 via-transparent to-background" />
    </div>
  );
};

export default WireframeBuilding;
